import React from 'react'
import classnames from 'classnames'
import TextArea from 'react-textarea-autosize'
import { If, Avatar } from 'src/Components'
import { DirectMessageButton } from 'src/Components/buyers/Button'
import styles from './QuestionSingle.module.scss'

const defaultProps = {
  inputValue: ''
}

const QuestionSingle = ({
  className,
  onChange,
  onSubmit,
  inputValue,
  name,
  placeholder,
  avatarUri,
  isLoading,
  onBlur,
  onFocus
}) => (
  <div
    data-qa='questionSingle'
    className={classnames(
      className,
      styles.question,
      avatarUri && styles.withAvatar
    )}
  >
    <TextArea
      className={styles.textarea}
      value={inputValue}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
    />
    <If condition={avatarUri}>
      <Avatar className={styles.avatar} src={avatarUri} />
    </If>
    <DirectMessageButton
      className={styles.button}
      disabled={!inputValue}
      loading={isLoading}
      onClick={onSubmit}
    />
  </div>
)

QuestionSingle.defaultProps = defaultProps

export default QuestionSingle
